import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { AdminHospitalInfo } from '../../contracts/hospital'

export const getAdminHospitalInfos = asBuilder((): AdminHospitalInfo[] => {
  return faker.helpers.multiple(() => ({
    id: faker.number.int(),
    hospitalInfo: {
      name: faker.lorem.sentence(),
      transls: {
        en: {
          name: faker.lorem.sentence(),
        },
        ja: {
          name: faker.lorem.sentence(),
        },
      },
    },
  }))
})
